module.exports = __webpack_public_path__ + "2c95025d51fd4160f64e987b855584ba.fbx";